export const GET_FAQS = "GET_FAQS"
export const SET_FAQS = "SET_FAQS"
export const GET_FAQ = "GET_FAQ"
export const SET_FAQ = "SET_FAQ"
export const DOWNLOAD_FAQ_DUMP = "DOWNLOAD_FAQ_DUMP"
export const UPDATE_FAQ = "UPDATE_FAQ"
export const CREATE_FAQ = "CREATE_FAQ"
export const SET_FAQ_LOADER = "SET_FAQ_LOADER"
export const DELETE_FAQ_SCHEMA = "DELETE_FAQ_SCHEMA"